/**
 * Compute per-line shipped / remaining from order items + recorded shipments.
 * Keeps admin "Fulfilled" accurate even if the API omits quantity_shipped.
 *
 * @param {Array<{ id?: number, product_external_id?: string, quantity?: number, quantity_shipped?: number, quantity_remaining?: number }>} items
 * @param {Array<{ items?: Array<{ order_item_id?: number, product_external_id?: string, quantity?: number }> }>} shipments
 */
export function itemsWithFulfillment(items, shipments) {
  const byId = {};
  const byExt = {};
  for (const s of shipments || []) {
    for (const si of s?.items || []) {
      const id = Number(si.order_item_id) || 0;
      const ext = String(si.product_external_id || '').trim();
      const q = Math.max(0, Number(si.quantity) || 0);
      if (id > 0) byId[id] = (byId[id] || 0) + q;
      if (ext) byExt[ext] = (byExt[ext] || 0) + q;
    }
  }

  return (items || []).map((it) => {
    const id = Number(it.id) || 0;
    const ext = String(it.product_external_id || '').trim();
    const qty = Math.max(0, Number(it.quantity) || 0);
    let shipped = Math.max(0, Number(it.quantity_shipped) || 0);
    if (id > 0 && byId[id]) shipped = Math.max(shipped, byId[id]);
    if (ext && byExt[ext]) shipped = Math.max(shipped, byExt[ext]);
    shipped = Math.min(qty, shipped);
    return {
      ...it,
      quantity_shipped: shipped,
      quantity_remaining: Math.max(0, qty - shipped),
    };
  });
}

export function orderHasUnshippedItems(items) {
  return itemsWithFulfillment(items, []).some((it) => (it.quantity_remaining ?? 0) > 0);
}
